import React from "react";
import { Message, ImageProps, Placeholder } from "semantic-ui-react";
import { isLoaded, isLoadErrored } from "../../sg-core/models/ILoadable";
import { useFileUploadService } from "../context/FileUploadServiceContext";
import useFileToken from "../hooks/useFileToken";
import { Upload6 } from "../../endpoints"


interface IImageProps extends ImageProps {
    id: string;
    title: string
}

const getFileUrl = (baseUrl: string, fileId: string, token: string): string => {
    return [
        baseUrl,
        "?action=hae_tiedosto&varmenne=",
        token,
        "&tiedosto=",
        fileId,
    ].join("");
};

const FileView: React.FC<IImageProps> = ({ id, title, ...imgProps }) => {
    const fileService = useFileUploadService();

    if (!fileService) {
        throw new Error("ImageView cannot exists without an SG fileupload context.");
    }

    const fileToken = useFileToken();
    let shortTitle = title.length > 40 ? `${title.substr(0, 40)}...` : title;

    if (isLoaded(fileToken)) {
        const fileUrl = getFileUrl(
            Upload6.path,
            id,
            fileToken.data,
        );
        return <a href={fileUrl} title={title}> {shortTitle} </a>;
    }

    if (isLoadErrored(fileToken)) {
        return <Message negative compact>Tiedoston lataus ei onnistunut</Message>;
    }

    return <Placeholder> <Placeholder.Line /> </Placeholder>;
};

export default FileView;
